import axiosFactory from "./axios.factory";

class ParcelService {
  async getMeta() {
    const result = await axiosFactory().get("/parcel/meta");
    return result.data.data;
  }

  async calculate(payload) {
    const result = await axiosFactory().post("/parcel/calculate", payload);
    return result.data.data;
  }

  async getTariffs(year) {
    const result = await axiosFactory().get(`/parcel/tariffs/${year}`);
    return result.data.data;
  }

  async saveTariffs(year, payload) {
    const result = await axiosFactory().put(`/parcel/tariffs/${year}`, payload);
    return result.data.data;
  }

  async searchProducts(keywords, limit = 20) {
    const result = await axiosFactory().get("/parcel/products", { params: { keywords, limit } });
    return result.data.data || [];
  }
}

export default new ParcelService();
